module.exports = __webpack_public_path__ + "static/media/l_makeup.71428104.png";